import { Box, SxProps } from '@mui/material';
import ArrowUpPrimary from './ArrowUpPrimary.svg';

type Props = {
  color?: 'primary' | 'default';
  width?: number;
  height?: number;
  sxProps?: SxProps;
};

export function ArrowUpIcon({
  color = 'primary',
  width = 24,
  height = 24,
  sxProps,
}: Props) {
  const icon = color === 'primary' ? ArrowUpPrimary : '';

  return (
    <Box
      component="img"
      src={icon.src}
      width={width}
      height={height}
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        ...sxProps,
      }}
    />
  );
}
